import { combineReducers } from 'redux'

import { cartReducer } from './cart'
import { homeReducer } from './home'
import { leadReducer } from './lead'
import { internalProductReducer } from './internalProduct'
import { bankReducer } from './bank'
import { requestReducer } from './request'

export default combineReducers({
    cart: cartReducer,
    home: homeReducer,
    lead: leadReducer,
    request: requestReducer,
    internalProduct: internalProductReducer,
    bank: bankReducer
})
